import { useEffect, useState, useMemo } from 'react';

/**
 * 시나리오 챗봇 영업시간 분기 훅
 *
 * 백엔드에 운영시간 조회 API가 없어 FE 정적 비교로 처리.
 * 정본: planning/chatbot/07_최종_통합_시나리오.md (0.3 글로벌 운영시간)
 *
 * 정책:
 *   - 일반 상담 채널 (카카오톡·Line·전화): 평일 09:00 ~ 18:00
 *   - WhatsApp: 24시간
 *   - 이메일·문의 게시판: 24시간 접수, 답변은 영업시간
 *   - 휴일·공휴일: 1차 자동 분기 X (백엔드 휴일 API 미존재 → 카피로만 안내)
 *
 * 1분 단위로 자동 갱신 (영업 종료 시점에 사용자가 챗봇 사용 중인 케이스 처리).
 *
 * 반환:
 *   {
 *     isOpen: boolean,           // 현재 영업 중 여부
 *     isWhatsApp24h: boolean,    // WhatsApp 항상 활성 (true 고정, 정책 변경 시만 갱신)
 *     isEmailAccepting: boolean, // 이메일·문의 24h 접수 (true 고정)
 *     isWeekday: boolean,        // 평일 여부
 *     hour: number,              // 현재 시각 (시)
 *   }
 */
export default function useBusinessHours() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    // 매 분 1회 갱신 (영업 시작/종료 시점 반영)
    const interval = setInterval(() => setNow(new Date()), 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return useMemo(() => {
    const day = now.getDay();        // 0=일요일, 6=토요일
    const hour = now.getHours();
    const isWeekday = day >= 1 && day <= 5;
    const isOpenHour = hour >= 9 && hour < 18;
    const isOpen = isWeekday && isOpenHour;

    return {
      isOpen,
      isWhatsApp24h: true,
      isEmailAccepting: true,
      isWeekday,
      hour,
    };
  }, [now]);
}
